// Paleta propia del widget de chat. Historial: partio en el azul/indigo del
// resto de la app, Seba pidio morado fluorescente para diferenciarlo, y
// despues de probarlo en el navegador volvio a pedir azul -- esta vez en
// degrade con un tono mas claro para una sensacion "tech" (ver conversacion
// del 29/08). El oscuro es el mismo primary.main del theme global de MUI
// (ver src/ui/styles/defaultTheme.ts) para que el widget se sienta parte de
// la app en vez de un color inventado aparte.
export const AI_CHAT_ACCENT_DARK = '#1e293b'; // azul marino -- igual al primary.main global
export const AI_CHAT_ACCENT_LIGHT = '#3b82f6'; // celeste mas claro, la punta "tech" del degrade
export const AI_CHAT_GRADIENT = `linear-gradient(135deg, ${AI_CHAT_ACCENT_DARK} 0%, ${AI_CHAT_ACCENT_LIGHT} 100%)`;
export const AI_CHAT_GRADIENT_HOVER = `linear-gradient(135deg, #0f172a 0%, #2563eb 100%)`;
